import React from 'react';
import Header from '../components/Header';
import InfoPageContent from '../components/InfoPageContent';
import Chatbot from '../components/Chatbot';

const InfoPage = () => {
  return (
    <div className="min-h-screen bg-[#020617] text-slate-100 noise-bg">
      <Header />
      <div className="pt-24">
        <InfoPageContent />
      </div>
      <Chatbot />
    </div>
  );
};

export default InfoPage;
